//Keyboard input

import { useEffect, useCallback } from 'react';

interface KeyboardConfig {
  onArrowKey: (direction: 'up' | 'down' | 'left' | 'right') => void;
  onSpacebar: () => void;
  onEscape: () => void;
  enabled?: boolean;
}

export const useKeyboard = ({ 
  onArrowKey, 
  onSpacebar, 
  onEscape, 
  enabled = true 
}: KeyboardConfig) => {
  
  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    if (!enabled) return;
    
    //Prevent default behavior for game keys
    if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', ' ', 'Escape'].includes(event.key)) {
      event.preventDefault();
    }
    
    switch (event.key) {
      case 'ArrowUp':
        onArrowKey('up');
        break;
      case 'ArrowDown':
        onArrowKey('down');
        break;
      case 'ArrowLeft':
        onArrowKey('left');
        break;
      case 'ArrowRight':
        onArrowKey('right');
        break;
      case ' ': //Spacebar
        onSpacebar();
        break;
      case 'Escape':
        onEscape();
        break;
    }
  }, [onArrowKey, onSpacebar, onEscape, enabled]);

  useEffect(() => {
    if (enabled) {
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [handleKeyDown, enabled]);
};

export default useKeyboard;
